var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAuthorizationData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0a2 2 0 0 0-2 2v11c0 1.1.9 2 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm1.18 10.8h4.24a.88.88 0 0 0 .7-.35.85.85 0 0 0 .13-.76 3.18 3.18 0 0 0-2.03-2.05.22.22 0 0 1-.14-.19.21.21 0 0 1 .1-.2 1.76 1.76 0 0 0 .87-1.32A1.76 1.76 0 0 0 6.6 4.6 1.81 1.81 0 0 0 5.3 4c-.4 0-.78.12-1.09.36a1.75 1.75 0 0 0-.56 2.05c.15.36.41.65.75.85a.21.21 0 0 1 .11.2.21.21 0 0 1-.15.18 3.26 3.26 0 0 0-2 2.05.84.84 0 0 0 .13.76.86.86 0 0 0 .7.34Zm7.6 0h3.15c.2 0 .4-.09.55-.23a.77.77 0 0 0 0-1.1.8.8 0 0 0-.55-.22h-3.14a.8.8 0 0 0-.56.22.77.77 0 0 0 0 1.1.8.8 0 0 0 .56.22Zm5.85-.14a.8.8 0 0 0 1-.1.77.77 0 0 0-.26-1.25.8.8 0 0 0-.85.16.77.77 0 0 0 .11 1.2ZM10.8 7.1h6.28c.21 0 .41-.08.56-.23a.77.77 0 0 0 0-1.09.8.8 0 0 0-.56-.22H10.8a.8.8 0 0 0-.56.22.77.77 0 0 0 0 1.1.8.8 0 0 0 .56.22Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 15h6v3H7v-3Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 18.5c0-.28.22-.5.5-.5h13c.28 0 .5.22.5.5v1a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAuthorizationData);
export default ForwardRef;